export class ContextModel {
  token: string = "";
  tokenExpiryTime: string = "";
  isFatchinToken: boolean = false;
  userId: number = 0;
  userKey: string = "";
  // userRole: any = [];
  userRole: any = "";
  userGroupId: number = 0;
  userGroupName: string = "";
  loginClick: boolean = true;
  firstName: string = "";
  lastName: string = "";
  fullName: string = "";
  email: string = "";
  countryID: number = 91;
  consumerId: number = 0;
  consumerName: string = "";
  buyerId: number = 0;
  buyerIdForDefaultDeliveryAddress: number = 0;
  branchId: number = 0;
  branchGstNumber: string = "";
  branchLutNumber: string = "";
  selectedFirmId: number = 0;
  selectedBranchId: number = 0;
  firmId: number = 0;
  firmName: string = "";
  firmPanNumber: string = "";
  firmIndustryType: string = "";
  firmBusinessAs: string = "";
  financialYear: string = "";
  currentFinancialYear: string = "";
  previousFinancialYear: string = "";
  financialYearStartDate: string = "";
  financialYearEndDate: string = "";
  isTrialActive: number = 0;
  trailEndDays: number = 0;
  remainingDays: number = 0;
  trialStartDate: string = "";
  subscriptionId: number = 0;
  planStartDate: string = "";
  planEndDate: string = "";
  branchName: string = "";
  stateId: number = 0;
  stateCode: string = "";
  stateShortName: string = "";
  isStateUT: boolean = false;
  isBomEnable: boolean = false;
  maxAllowedAdmins: number = 0;
  maxAllowedUsers: number = 0;
  maxAllowedBranches: number = 0;
  maxAllowedFirms: number = 0;
  enablePos: boolean = false;
  enablePosForFirm: boolean = false;
  defaultBarcodeType: string = "barcode";
  defaultBarcodeSubType: string = "CODE128";
  defaultBarcodePrintPaperType: string = "A4";
  defaultInvoice: string = "";
  defaultPaymentVoucher: string = "";
  defaultJournalVoucher: string = "";
  defaultLR: string = "";
  defaultQuotation: string = "";
  isBomEnabled: boolean = false;
  enablePTR: boolean = false;
  enableEWayBill: boolean = false;
  enableEInvoice: boolean = false;

  isAlert: boolean = false;
  enableCompositionTax: boolean = false;
  enableBatchwiseTax: boolean = false;
  enableFreeQuantity: boolean = false;
  alertMessage: string = "";
  alertType: string = "success";

  isLoadding: boolean = false;
  isMenuVisible: boolean = false;

  isThemeDark: boolean = false;
  isUnauthorized: boolean = false;
  AndroidAppVersion: string = "";
  AndroidBuildNumber: number = 0;
  organizationId: number = 0;
  organizationName: string = "";
  loginDetail: LoginDetail = new LoginDetail();
  systemConfigurationColl: Array<SystemConfiguration> = [];
  systemConfigurationDetailColl: Array<SystemConfigurationDetail> = [];
  menuAccessColl: Array<MenuAccess> = [];

  mode: any;

  warehouseId: number = 0;
  warehouseName: string = "";

  defaultLabelId: number = 0;
  enableStickyHeader: boolean = false;
  defaultLabelName: string = "";
  refetchAccountCollForSaleReceipt: boolean = true;
  sourceAccountCollectionForSalesReceipt: Array<any> = [];
  transactionModeColl: Array<any> = [];
  refetchwarehouseColl: boolean = true;
  warehouseColl: Array<any> = [];
  refetchLabelColl: boolean = true;
  labelColl: Array<any> = [];

  refetchCountryRegionColl: boolean = true;
  countryRegionColl: Array<any> = [];

  refetchSaleDueOnTypeColl: boolean = true;
  saleDueOnTypeColl: Array<any> = [];

  refetchSaleStatusColl: boolean = true;
  saleStatusForPage: string = "";
  saleStatusColl: Array<any> = [];
  emailSettingId: number = 0;
  reasonForCancelColl: Array<any> = [];
  refetchReasonForCancelColl: boolean = true;
}
export class LoginDetail {
  token: string = "";
  tokenExpiryTime: string = "";
  userId: number = 0;
  userKey: string = "";
  userRole: any = "";
  loginClick: boolean = true;
  prefix: string = "";
  firstName: string = "";
  lastName: string = "";
  fullName: string = "";
  email: string = "";
  countryID: number = 91;
  isAuthorized: boolean = true;
}

export class SystemConfiguration {
  systemConfigurationId: number = 0;
  masterSystemConfigurationId: number = 0;
  // configurationKeyLabel: string;
  configModule: string = "";
  configValue: string = "";
  configKey: string = "";
  configKeyLabel: string = "";
  configDataType: string = "";
  isLocked: boolean = false;
  isDeleted: boolean = false;
}

export class SystemConfigurationDetail {
  systemConfigurationId: number = 0;
  systemConfigurationDetailId: number = 0;
  masterSystemConfigurationId: number = 0;
  parentConfigurationModule: string = "";
  configModule: string = "";
  configKey: string = "";
  configKeyLabel: string = "";
  configValue: string = "";
  configDataType: string = "";
  displayOrder: number = 0;
  isLocked: boolean = false;
  isDeleted: boolean = false;
}

export class MenuAccess {
  menuId: number = 0;
  userGroupMenuAccessId: number = 0;
  name: string = "";
  code: string = "";
  locatin: string = "";
  parentMenuCode: string = "";
  menuUrl: string = "";
  displayOrder: number = 0;
  hasViewAccess: boolean = false;
  hasInsertAccess: boolean = false;
  hasUpdateAccess: boolean = false;
  hasDeleteAccess: boolean = false;
  hasImportAccess: boolean = false;
  hasExportAccess: boolean = false;
}
